"use client"
import { useEffect } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import toast from 'react-hot-toast';


interface NetworkStatusProps extends React.PropsWithChildren {

}
export const NetworkStatus = ({ children }: NetworkStatusProps) => {
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if (!isOnline) {
      toast.error('当前网络离线，暂无法使用，请联网后重试。', {
        duration: 5000,
        style: { minWidth: '380px' },
      });
    }
  }, [isOnline])

  return children;
};

